import { useEffect, useState } from 'react';
import { useWatch, UseFormReturn } from 'react-hook-form';
import { UserOption, EditUnitFormType } from '@mark43/cad-api';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';

const getNumberOfValidPersonnel = (personnel: UserOption[]) =>
    personnel?.filter((personnel) => !!personnel?.value)?.length ?? 0;

export function useSetStaffCountBasedOnPersonnel(
    form: UseFormReturn<EditUnitFormType>,
    isEditUnit: boolean
) {
    const { staffCountEnabled } = useEnabledFeatures();
    const personnel = useWatch({ control: form.control, name: 'personnel' });
    const staffCount = useWatch({ control: form.control, name: 'staffCount' });
    const [firstPersonnelNumberUpdateRan, setFirstPersonnelNumberUpdateRan] = useState(false);
    const [currentNumberOfValidPersonnel, setCurrentNumberOfValidPersonnel] = useState(
        getNumberOfValidPersonnel(personnel)
    );

    useEffect(() => {
        setCurrentNumberOfValidPersonnel(getNumberOfValidPersonnel(personnel));
    }, [personnel]);

    useEffect(() => {
        if (!staffCountEnabled) {
            return;
        }

        const newNumberOfValidPersonnel = getNumberOfValidPersonnel(personnel);
        const newStaffCount =
            Number(staffCount ?? 0) + newNumberOfValidPersonnel - currentNumberOfValidPersonnel;

        if (
            (isEditUnit && !firstPersonnelNumberUpdateRan) ||
            newNumberOfValidPersonnel === currentNumberOfValidPersonnel ||
            newStaffCount < 0 ||
            (staffCount === undefined && newNumberOfValidPersonnel < currentNumberOfValidPersonnel)
        ) {
            if (
                !firstPersonnelNumberUpdateRan &&
                newNumberOfValidPersonnel !== currentNumberOfValidPersonnel
            ) {
                setFirstPersonnelNumberUpdateRan(true);
            }

            return;
        }

        form.setValue('staffCount', newStaffCount);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personnel]);
}
